// api/axiosInstance.js
import axios from "axios";
import { decryptData, encryptData } from "./encryptionUtils";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_LINK,
  headers: {
    "x-security-key": process.env.REACT_APP_SECURITY_KEY,
  },
});

// Request interceptor: encrypt outgoing data (skip FormData)
axiosInstance.interceptors.request.use((config) => {
  if (config.data instanceof FormData) {
    // Let axios handle multipart automatically
    return config;
  }

  if (config.data) {
    config.headers["Content-Type"] = "application/json"; // ensure JSON only when encrypting
    config.data = { payload: encryptData(config.data) };
  }

  return config;
});

// Response interceptor: decrypt incoming data
axiosInstance.interceptors.response.use((response) => {
  if (response.data && response.data.payload) {
    response.data = decryptData(response.data.payload);
  }
  return response;
});

export default axiosInstance;
